import {Component, Input, Output, EventEmitter, OnInit, SimpleChange, OnChanges} from '@angular/core';
import { Router } from '@angular/router';
import { UploaderService } from './uploader.service';
import { NotificationService } from 'app/core/services/notification.service';
import { ConfigService } from 'app/core/services/config.service';

import { UtilService } from 'app/core/services/util.service';

declare var $: any;
@Component({
    selector: 'itpx-uploader',
    templateUrl: './uploader.component.html',
    styleUrls: ['./uploader.component.css']
})
export class UploaderComponent implements OnInit, OnChanges {
    @Input() uploadedFileName: string;
    @Input() dimensions: { width: number, height: number, comp: string };
    @Input() type: Array<any>;
    @Input() component: string;
    @Input() cancelRoute: string;
    @Input() saveRoute: string;
    @Input() imgSrc: string;
    @Input() droppedFile: File;
    @Input() name: string;
    @Input() bucket: string;
    @Input() showPreviewImg: boolean = true;
    @Input() showProgress: boolean = true;
    @Input() id: string;
    @Input() showCancelBtn: boolean = true;
    @Input() hiddeButtons: boolean = false;
    @Input() delegateSave: boolean;
    @Input() placeholder: string;
    @Input() autoSave: boolean = false;
    @Input() hidePreviewImage: boolean = false;
    @Input() giveMeOnlyTheUrl: boolean = false;
    @Input() maxFileSize: number;
    @Input() minFileSize: number;
    @Input() requirements: any;
    @Input() disableUploading: boolean = false;
    @Input() useNotification: boolean = true;
    @Output() complete = new EventEmitter();
    @Output() saveFinished: EventEmitter<any> = new EventEmitter();
    @Output() unsavedData = new EventEmitter();
    @Output() onCancelEvent = new EventEmitter();
    @Output() inProgress = new EventEmitter();

    protected file: File;
    public fileName: string;
    public details: any;
    public isUploading: boolean = false;
    public progress: number;
    public reader: FileReader = new FileReader();
    public validInput: boolean = false;
    public imgSrcInvalid: boolean = false;
    public errorMessage: string;

    isInProgress: boolean = false;

    constructor(
        public notificationService: NotificationService,
        public uploaderService: UploaderService,
        public router: Router,
        public utilService: UtilService,
        public configService: ConfigService
    ) { }

    ngOnInit() {
        if (!this.bucket) this.bucket = this.configService.get('aws').uploadsBucket;
        if (!this.component)
            throw new Error('ITPx Upload component cannot work without [component]');
    }
    ngOnDestroy() {
        this.endProgress();
    }
    ngOnChanges(changes: {[propKey: string]: SimpleChange}) {
        if(changes['disableUploading'] && changes['disableUploading'].currentValue) {
            $('.image-preview-input').addClass('disabled-input');
        }

        if (changes['disableUploading'] && !changes['disableUploading'].currentValue) {
            $('.image-preview-input').removeClass('disabled-input');
        }

    }
    startProgress() {
        this.errorMessage = '';
        this.isInProgress = true;
        this.inProgress.emit(true);
        this.utilService.startProgress();
    }
    endProgress() {
        this.isInProgress = false;
        this.inProgress.emit(false);
        this.utilService.endProgress();
    }

    public onChange(event: any) {
        this.unsavedData.emit(true);
        let file = event.target.files[0] || event.srcElement.files[0];
        this.onFileChange(file);
    }

    private onDnDFileChange(event: any) {
        if (!this.disableUploading) {
            this.onFileChange(event);
        }
    }
    public onFileChange(file) {
        this.readFile(file);

        if (this.validateFile(file)) {
            if (this.dimensions) {
                this.validateDimensions(file);
                return;
            }
            if (this.maxFileSize && file.size > (this.maxFileSize + 1) * 1048576){
                const error = 'File must be of size max ' + this.maxFileSize + ' mb';
                if (this.useNotification) {
                    this.notificationService.error(
                        error,
                        'Failed'
                    );
                } else {
                    this.errorMessage = error;
                }
                
            }else if(this.minFileSize && file.size <= this.minFileSize){
                const error = 'File must not be empty';
                if (this.useNotification) {
                    this.notificationService.error(
                        error,
                        'Failed'
                    );
                } else {
                    this.errorMessage = error;
                }
            }else {
                this.validInput = true;
                this.file = file;
                this.fileName = this.file.name;
                this.imgSrcInvalid = false;
                if (this.autoSave) this.onSave();
            }
        } else {
            this.validInput = false;
            this.fileName = '';
            this.imgSrcInvalid = true;
            const error = 'File must be of type ' + this.type.join(', ');
            if (this.useNotification) {
                this.notificationService.error(
                    error,
                    'Failed'
                );
            } else {
                this.errorMessage = error;
            }
            return false;
        }
    }

    private validateFile(file: File) {
        if (this.type) {
            let isTypeValid;
            for (let el of this.type) {
                if (file.type.indexOf(el) >= 0) {
                    isTypeValid = true;
                    break;
                } else {
                    let fileNameSplit = file.name.split('.');
                    let fileExtension = fileNameSplit[fileNameSplit.length - 1];
                    if (fileExtension.indexOf(el) >= 0) {
                        isTypeValid = true;
                        break;
                    }
                    isTypeValid = false;
                }
            }
            if (file.type.indexOf('image') === -1) {
                this.imgSrcInvalid = true;
            }
            return isTypeValid;
        }  else {
            return true;
        }
    }

    private validateDimensions(file: File) {
        let img = new Image();
        img.src = window.URL.createObjectURL(file);
        img.onload = () => {
            let result: boolean;
            switch (this.dimensions.comp) {

                case 'eq':
                    result = (!this.dimensions.height || this.dimensions.height === img.naturalHeight)
                        && (!this.dimensions.width || this.dimensions.width === img.naturalWidth);
                    break;
                case 'geq':
                    result = (!this.dimensions.height || this.dimensions.height <= img.naturalHeight)
                        && (!this.dimensions.width || this.dimensions.width <= img.naturalWidth) && (img.naturalWidth == img.naturalHeight);
                    break;
                case 'max':
                    result = (!this.dimensions.height || this.dimensions.height >= img.naturalHeight)
                        && (!this.dimensions.width || this.dimensions.width >= img.naturalWidth);
                    break;
                default:
                    result = (!this.dimensions.height || this.dimensions.height <= img.naturalHeight)
                        && (!this.dimensions.width || this.dimensions.width <= img.naturalWidth);
                    break;

            }
            if (result) {
                this.validInput = true;
                this.file = file;
                this.fileName = this.file.name;
                this.imgSrcInvalid = false;
                if (this.autoSave) this.onSave();
            } else {
                if(this.dimensions && 'geq' == this.dimensions.comp){
                    this.notificationService.error(
                        `Please upload a PNG/JPG of at least 500px, with an aspect ratio of 1:1`,
                        'Failed'
                    );
                }else{
                    const comparator = !this.dimensions.comp || 'geq' == this.dimensions.comp ? 'at least /and the same':  ('min' === this.dimensions.comp ? 'at least' : 'max' === this.dimensions.comp ? 'at most' : 'exactly') ;
                this.notificationService.error(
                    `File must be ${comparator} ${this.dimensions.width}x${this.dimensions.height}`,
                    'Failed'
                );
                }

            }
        }
    }

    public onSave() {
        this.startProgress();

        this.uploaderService.storeFileDetails(this.file, this.component, this.bucket).subscribe(
            body => {
                this.details = body.data;
                this.upload();
            },
            error => this.endProgress()
        );
    }

    public upload(info?) {
        this.isUploading = true;
       if(info) {
           this.uploaderService
               .uploadContent(info.file, info.fileName, info.bucket)
               .subscribe(data => {
                   this.progress = data.progress;
                   if (data.completed) {
                       this.progress = 100;
                       this.completeUpload(data);
                   }
               });
       } else {
           this.uploaderService
               .uploadContent(this.file, this.details.fileName, this.bucket)
               .subscribe(data => {
                   this.progress = data.progress;
                   if (data.completed) {
                       this.progress = 100;
                       this.completeUpload(data);
                   }
               });
       }

    }

    private completeUpload(data: any) {
        if (!this.giveMeOnlyTheUrl) {
            this.uploaderService.completeFileDetails(this.details.id, this.id).subscribe(
                body => {
                    this.isUploading = false;
                    this.endProgress();
                    const updatedData = {
                        ...body['data'],
                        path: this.configService.getSphinxUrlUnsecured(
                            'phoenix2',
                            body['data']['bucket'],
                            body['data']['key']
                        )
                    };
                    this.complete.emit({data: updatedData});
                    if (!this.delegateSave) {
                        this.router.navigate([this.saveRoute]);
                    } else {
                        this.saveFinished.emit({ data: {...updatedData, fileName: this.fileName} });
                    }
                },
                error => {
                    this.endProgress();
                }
            );
        } else {
            this.isUploading = false;
            this.endProgress();
            this.complete.emit({
                data: data
            });
        }
    }

    private extractData(body: any) { }

    private readFile(file) {
        this.reader.readAsDataURL(file);
        //NOTE: The following condition prevents scanning of files > 10MB
        //It is necessary because it prevents blovking the event loop and breaking the browser
        if (file.size < 10 * 1024 * 1024) {
            this.reader.onload = function (e) {
                if (e.target.result.indexOf('data:text/xml') > -1) {
                    this.imgSrc =
                        this.configService.get('aws').downloadUrl + this.configService.get('images').xmlIcon;
                } else if (e.target.result.indexOf('data:application/vnd.ms-excel') > -1) {
                     this.imgSrc = null;
                } else {
                    this.imgSrc = e.target.result || e.srcElement.result;
                }
            }.bind(this);
        }
    }

    private onCancel() {
        if (this.cancelRoute) {
            this.router.navigate([this.cancelRoute])
        } else {
            this.onCancelEvent.emit('canceled')
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/uploader/uploader.component.ts